import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Badge } from '../../components/ui/badge';
import { 
  Briefcase, 
  Plus,
  Edit,
  Trash2,
  Eye,
  ExternalLink,
  Image
} from 'lucide-react';
import { toast } from 'sonner';

const AdminPortfolioPage = () => {
  const [projects, setProjects] = useState([
    { id: '1', title: 'Refonte site e-commerce', client: 'TechCorp', category: 'Site web', image: '', published: true },
    { id: '2', title: 'Application mobile fitness', client: 'SportFit', category: 'App mobile', image: '', published: true },
    { id: '3', title: 'Identité visuelle restaurant', client: 'Le Gourmet', category: 'Branding', image: '', published: false },
  ]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[#1a365d]">Portfolio</h1>
          <p className="text-[#64748b]">Gérez vos réalisations mises en avant sur le site</p>
        </div>
        <Button className="bg-amber-600 hover:bg-amber-700">
          <Plus className="w-4 h-4 mr-2" />
          Ajouter un projet
        </Button>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {projects.map((project) => (
          <Card key={project.id} className="overflow-hidden hover:shadow-md transition-shadow">
            <div className="aspect-video bg-slate-100 flex items-center justify-center">
              {project.image ? (
                <img src={project.image} alt={project.title} className="w-full h-full object-cover" />
              ) : (
                <Image className="w-12 h-12 text-slate-300" />
              )}
            </div>
            <CardContent className="p-4">
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="font-semibold text-[#1a365d]">{project.title}</h3>
                  <p className="text-sm text-[#64748b]">{project.client}</p>
                  <Badge variant="outline" className="mt-2">{project.category}</Badge>
                </div>
                <Badge variant={project.published ? 'default' : 'secondary'}>
                  {project.published ? 'Publié' : 'Brouillon'}
                </Badge>
              </div>
              <div className="flex gap-2 mt-4">
                <Button variant="outline" size="sm" className="flex-1">
                  <Edit className="w-3 h-3 mr-1" /> Éditer
                </Button>
                <Button variant="ghost" size="icon">
                  <Eye className="w-4 h-4" />
                </Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AdminPortfolioPage;
